import React from 'react';
import { IconMonogram, IconInstagram } from './ui/Icons';
export function Footer() {
  const scrollToTop = (e: React.MouseEvent) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer className="bg-brand-mocha text-brand-cream pt-16 pb-8 border-t border-brand-gold/20" data-id="element-106">
      <div className="container mx-auto px-6 md:px-12" data-id="element-107">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-8 mb-12 border-b border-brand-cream/10 pb-12" data-id="element-108">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-109">
            <a href="#inicio" onClick={scrollToTop} className="mb-4 inline-block" data-id="element-110">
              <IconMonogram className="w-16 h-16 text-brand-cream" data-id="element-111" />
            </a>
            <h3 className="font-serif text-xl mb-2" data-id="element-112">CF Studio</h3>
            <p className="text-brand-cream/60 text-sm max-w-xs" data-id="element-113">
              Uñas & Cuidado Capilar.
              <br data-id="element-114" />
              Resaltando tu belleza natural con técnicas de vanguardia.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-col items-center md:items-end gap-4" data-id="element-115">
            <h4 className="font-serif text-lg mb-2" data-id="element-116">Enlaces Rápidos</h4>
            <nav className="flex flex-wrap justify-center md:justify-end gap-x-6 gap-y-2 text-sm text-brand-cream/70" data-id="element-117">
              <a href="#servicios" className="hover:text-brand-rose transition-colors" data-id="element-118">
                Servicios
              </a>
              <a href="#galeria" className="hover:text-brand-rose transition-colors" data-id="element-119">
                Galería
              </a>
              <a href="#sobre-mi" className="hover:text-brand-rose transition-colors" data-id="element-120">
                Sobre mí
              </a>
              <a href="#contacto" className="hover:text-brand-rose transition-colors" data-id="element-121">
                Contacto
              </a>
            </nav>
            <a href="https://instagram.com/cfstudio.uy" target="_blank" rel="noopener noreferrer" className="mt-4 w-10 h-10 rounded-full bg-brand-cream/10 flex items-center justify-center hover:bg-brand-rose hover:text-white transition-all" aria-label="Instagram" data-id="element-122">
              <IconInstagram className="w-5 h-5" data-id="element-123" />
            </a>
          </div>
        </div>

        <div className="text-center text-xs text-brand-cream/40 flex flex-col md:flex-row justify-between items-center gap-2" data-id="element-124">
          <p data-id="element-125">
            © 2024 CF Studio · Candelaria Fernandez. Todos los derechos
            reservados.
          </p>
          <p data-id="element-126">Montevideo, Uruguay</p>
        </div>
      </div>
    </footer>;
}